import Text from 'components/Text/Text';
import React, { useContext, useMemo } from 'react';
import { IGameAssignmentContext, GameAssignmentContext } from '../../../../gameAssignmentState/gameAssignmentContext';
import Restaurant from './components/Restaurant';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './Restaurants.module.scss';

const Restaurants: React.FC = () => {
	const { setIDsSelectedCustomers, IDsSelectedCustomers, searchStringForRestaurants, restaurants } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	const filteredRestaurants = useMemo(() => {
		if (searchStringForRestaurants) {
			const updatedRestaurants = restaurants.map((el) => {
				const filteredRestaurantsByName = el.restaurants.filter((restaurant) =>
					restaurant.address?.toLowerCase().includes(searchStringForRestaurants.toLowerCase()),
				);
				return { ...el, restaurants: filteredRestaurantsByName };
			});
			return updatedRestaurants;
		}
		return restaurants;
	}, [searchStringForRestaurants, restaurants]);

	const changeCloseStatus = (customerID: string) => {
		const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
		copyIDsSelectedCustomers[customerID] = !copyIDsSelectedCustomers[customerID];
		setIDsSelectedCustomers(copyIDsSelectedCustomers, false);
	};

	const deleteCustomer = (customerID: string) => {
		const copyIDsSelectedCustomers = { ...IDsSelectedCustomers };
		delete copyIDsSelectedCustomers[customerID];
		setIDsSelectedCustomers(copyIDsSelectedCustomers, true);
	};

	return (
		<div data-test="Restaurants">
			{filteredRestaurants.map((el) => {
				const wrapperClasses = classNames(style.wrapper, {
					[style.collapsedWrapper]: !IDsSelectedCustomers[el.customerId],
				});

				return (
					<div key={el.customerId + 'mainDisplayRestaurantsTab'}>
						<div className={wrapperClasses}>
							<div className={style.category}>
								<div className={style.name} onClick={() => changeCloseStatus(el.customerId)}>
									<Text
										translationKey={el.customerName}
										theme={!IDsSelectedCustomers[el.customerId] ? 'secondary' : 'contrast'}
										withTooltip={true}
									/>
									<svg className={style.pointerIcon}>
										<use xlinkHref={`${breadcrumbs}#next`} />
									</svg>
								</div>
								<svg className={style.closeIcon} onClick={() => deleteCustomer(el.customerId)}>
									<use xlinkHref={`${breadcrumbs}#close`} />
								</svg>
							</div>
							<div className={style.subcategory}>
								{el.restaurants.length ? (
									<Restaurant data={el.restaurants} />
								) : (
									<Text
										className={style.notification}
										translationNameSpace="listing"
										translationKey="noRestaurantsLabel"
										theme="errorDark"
										weight="bold"
										align="center"
									/>
								)}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

export default Restaurants;
